module.exports = __webpack_public_path__ + "img/svg1.b0814553.svg";